<template>
  <div>
    <div class="modal fade" id="login" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content" style="background-color: rgba(60,60,60,.95);">
                <div class="modal-header2 p-0" style="">
                    <h6 class="modal-title" id="exampleModalLabel">{{ translate('enter') }}
                        <button id="closeLogin" :style="skin.my_account.close_btn" style="background:transparent;float: right;color:white" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                    </h6>
                </div>
                <div class="modal-body p-4" style="height:30%">
                    <div class="text-center">
                        <!-- <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo" :width="skin.header_desktop.login_logo_width" alt=""><br><br> -->
                        <!-- <span>{{translate("you_registered")}}</span><br>
                        <span>{{translate("great_come")}}</span><br><br> -->
                        <form @submit.prevent="login()">
                            <div class="pb-2 font-size-custom mb-3 my-3" style="color:white;">
                                <i class="fas fa-user prefix lightgrey-text mx-2"></i>
                                <input v-model="username" id="username" type="text" :placeholder="translate('user')" class="login-user-control" autocomplete="off">
                            </div>
                            <div v-if="!resetPassword" class="pb-2 font-size-custom mb-3 my-3" style="color:white;">
                                <i class="fas fa-lock prefix lightgrey-text  mx-2"></i>
                                <input v-model="password" id="password" type="password" :placeholder="translate('password')" class="login-user-control" maxlength="16" autocomplete="off">
                            </div>
                            <div v-if="skin.reset_password" class="text-end mb-3">
                                <span @click="reset_password()" style="text-decoration: underline;cursor:pointer;">{{ translate("forgot_password") }}</span>
                            </div>
                            <br>
                            <div class="d-flex my-3">
                                <button class="btn p-2 mx-2" type="button" style="text-transform: uppercase; background-color: #292d3d!important;color:white;width:50%" data-bs-dismiss="modal" aria-label="Close">{{ translate('close') }}</button>
                                <button id="submit_btn" type="submit" class="btn p-2 mx-2" style="background-color: #292d3d!important;color:white;width:50%" :disabled="login_inProcess">{{ translate('enter') }}</button>
                            </div>
                        </form>
                        <div v-if="status.message!=''" :class="'alert alert-'+status.type" role="alert">{{ status.message }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
    name:"login",
    props:['skin','translation','language'],
    data(){
        return {
            username:"",
            password:"",
            resetPassword:false,
            status:{
                message:"",
                type:""
            },
            login_inProcess:false
        }
    },
    computed:{
    },
    methods:{
        async login(){
            this.login_inProcess = true;
            if(this.resetPassword){
                if(this.username!=""){
                    let reset = await axios.post(this.$store.getters["getDomain"]+"/swarm/remote/forgot_password",{
                        "email":this.username
                    })
                    if(reset.data.success){
                        this.status.message=reset.data.message;
                        this.status.type="success";
                    }
                    else{
                        this.status.message=reset.data.message;
                        this.status.type="danger";
                    }
                    this.resetPassword = false;
                }
                else{
                    this.status.message=this.translate("input_email");
                    this.status.type="danger"; 
                }
                this.login_inProcess = false;
            }
            else{
                let data = await this.$store.dispatch('login',{username:this.username,password:this.password});
                if(data=="success"){
                    document.getElementById('closeLogin').click();
                    this.$root.$emit('forceRender');
                    this.login_inProcess = false;
                    this.username = '';
                    this.password = '';
                    this.status.message = '';
                }
                else{
                    this.status.message=data;
                    this.status.type="danger";
                    this.login_inProcess = false;
                }
            }
            
        },
        reset_password(){
            this.resetPassword = true;
            this.login();
        },
        translate(text) {
            if(text){
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else{
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
    }
}
</script>

<style scoped>
.modal-header2 {
    margin-left: 5%!important;
    margin-right: 5%!important;
    margin-top: -1.25rem!important;
    margin-bottom: 0!important;
    height: 60px;
    padding: 1rem!important;
    color: #fff;
    border-bottom: none;
    background:linear-gradient(40deg,#292d3d,#03040d)!important
}
.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}
.login-user-control{
    color: #fff;
    margin-left: 2.5rem;
    width: calc(100% - 2.5rem);
    -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    -webkit-border-radius: 0;
    border-radius: 0;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent;
    margin: 0 0 0.5rem;
    -webkit-border-radius: 0;
    border-radius: 0;
    padding: 0.3rem 0 0.55rem;
    background-image: none;
    background-color: transparent;
    height: auto;
}
</style>